import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal, faLock } from "@fortawesome/free-solid-svg-icons";
import { PageNavContext } from "../../FunctionalPageLogin";

import './RightElements.css';

const LeaderboardCard = () => {
  const onPageNav = useContext(PageNavContext);

  const handleOpenClasament = (event) => {
    event.preventDefault();
    if (onPageNav) {
      onPageNav('Clasament');
    }
  };

  return (
    <div className="rightmenu-card leaderboard-card">
      <div className="section">
        <span className="get-pro-title">Clasament</span>
        <a href="#" className="section-link" onClick={handleOpenClasament}>Acceseaza</a>
        <div className="section-desc section-desc-leaderboard">
          <span className="locked-medal" aria-label="medalie blocata">
            <FontAwesomeIcon icon={faMedal} className="locked-medal-icon" />
            <FontAwesomeIcon icon={faLock} className="locked-medal-lock" />
          </span>
          Castiga 100 XP pentru a intra in clasament
        </div>
      </div>
    </div>
  );
};

export default LeaderboardCard;
